import { SectionHeader } from "components/SectionHeader";
import { SECTION_TITLES } from "../../copy/section-titles";

/** The count line under the title: how many people, and what to do next. */
export function attendeesLine(count: number): string {
  if (count === 0) return "Nobody is on the list yet.";
  if (count === 1) return "1 person. Tap their name to say hello.";
  return `${count} people. Tap a name to say hello.`;
}

/**
 * The head of the Attendees tab. It stays up through loading, error and empty
 * states so the tab does not jump when the directory arrives; only the count
 * line waits for a count.
 */
export function AttendeeHeader({ count }: { count?: number }) {
  return (
    <SectionHeader
      kicker={SECTION_TITLES.attendees.kicker}
      title={SECTION_TITLES.attendees.title}
      subline={count === undefined ? undefined : attendeesLine(count)}
      testId="attendees-header"
    />
  );
}
